module.exports = __webpack_public_path__ + "static/media/bobby.c89dac5f.jpg";